// imports
import { Address } from 'abitype';

// interfaces / types / consts
const API_KEY = process.env.REACT_APP_REST_API_KEY || '';
const BASE_URL = process.env.REACT_APP_REST_API_BASE_URL || '';

export interface Preferences {
  showCaptcha: boolean;
  bio: {
    email?: string;
    username?: string;
  };
  prompts: {
    avoidBio?: boolean;
    avoidNotifications?: boolean;
  };
  notifications: {
    email?: boolean;
    fcmToken?: string;
    newQuests?: boolean;
    questCompleted?: boolean;
  };
}
export interface Body {
  nonce: string;
  subscribe?: boolean;
  signedMessage: string;
  bio?: Partial<Preferences['bio']>;
  prompts?: Partial<Preferences['prompts']>;
  notifications?: Partial<Preferences['notifications']>;
}

// exports
export const get = (wallet: Address): Promise<Preferences> => {
  const URL = `${BASE_URL}/user/settings?wallet=${wallet}`;
  return fetch(URL, {
    headers: { 'Content-Type': 'application/json', 'x-api-key': API_KEY }
  }).then((response) => {
    const statusCode = response.status;
    if (statusCode === 404) { return Promise.resolve({}); }
    if (statusCode === 200) { return response.json().then((data) => data); }
    return response.json().then((errMsg) => Promise.reject(errMsg));
  });
};

export const post = (body: Body): Promise<boolean> => {
  const {
    nonce, signedMessage,
    bio, prompts, subscribe, notifications
  } = body;
  const setBio = Object.entries(bio || []).map(([key, value]) => ({ name: `bio.${key}`, value }));
  const setPrompts = Object.entries(prompts || []).map(([key, value]) => ({ name: `prompts.${key}`, value }));
  const setNotifications = Object.entries(notifications || []).map(([key, value]) => ({ name: `notifications.${key}`, value }));
  const set = [...setBio, ...setPrompts, ...setNotifications];
  const reqBody = JSON.stringify({
    set, nonce, subscribe, signed_message: signedMessage
  });
  return fetch(`${BASE_URL}/user/settings`, {
    body: reqBody,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'x-api-key': API_KEY }
  }).then((response) => {
    if (response.status === 200) { return Promise.resolve(true); }
    return response.json().then((errMsg) => Promise.reject(errMsg));
  });
};

export default { get, post };
